import { toE164, toNational, validate } from '@/utilities/formatPhoneNumber';

// The shipper's three contact slots on `clients`. Shared by ShipperAccount/Profile and the
// corporate shipper page, so both edit the same record by the same rules.

/**
 * @typedef {Object} ContactSlot
 * @property {string} key
 * @property {string} title Label on the corporate page.
 * @property {string|null} nameField Column for the name; the support slot has none.
 * @property {string} emailField
 * @property {boolean} [emailReadOnly] The primary email is the login email, which only Profile can change.
 * @property {string} phoneField
 * @property {boolean} [required] Profile.js won't save without a name and phone here.
 */

/** @type {ContactSlot[]} */
export const CONTACT_SLOTS = [
    {
        key: 'primary',
        title: 'EXECUTIVE SPONSOR',
        nameField: 'username',
        emailField: 'email',
        emailReadOnly: true,
        phoneField: 'business_phone',
        required: true,
    },
    {
        key: 'secondary',
        title: 'OPERATIONS · SHIPPER',
        nameField: 'secondary_username',
        emailField: 'secondary_email',
        phoneField: 'secondary_phone',
    },
    {
        key: 'support',
        title: 'ACCOUNTS',
        nameField: null,
        emailField: 'support_email',
        phoneField: 'support_phone',
    },
];

/** A stored phone for display: national format when it parses, as typed when it doesn't, `''` when unset. */
export const displayPhone = (phone) => (phone && validate(phone) ? toNational(phone) : phone || '');

/** A typed phone for storage: E.164 when it parses, as typed when it doesn't. */
export const storedPhone = (phone) => (validate(phone) ? toE164(phone) : phone);
